import { PASSWORD_RULES, failedRules } from '../../../shared/password.js';

/**
 * The five password rules, ticking off as they are met.
 *
 * Shown from the moment the box has anything in it rather than only
 * after a failed submit. Being told what was wrong is far less use than
 * being shown what is still missing while there is still a cursor in
 * the field - particularly for a child, who will otherwise try the same
 * password three times.
 *
 * The rules come from the same file the server validates against, so
 * this cannot quietly disagree with what will actually be accepted.
 */
export default function PasswordRules({ value = '', id }) {
  if (!value) return null;

  const missing = new Set(failedRules(value).map((r) => r.id));
  const met = PASSWORD_RULES.length - missing.size;
  const done = missing.size === 0;

  return (
    <div className={`pw-rules ${done ? 'is-done' : ''}`} id={id} aria-live="polite">
      <div className="pw-rules-head">
        <span className="pw-rules-bar" aria-hidden="true">
          <span style={{ width: `${(met / PASSWORD_RULES.length) * 100}%` }} />
        </span>
        <span className="pw-rules-count">
          {done ? 'All five ✓' : `${met} of ${PASSWORD_RULES.length}`}
        </span>
      </div>

      <ul>
        {PASSWORD_RULES.map((rule) => {
          const ok = !missing.has(rule.id);
          return (
            <li key={rule.id} className={ok ? 'is-met' : ''}>
              <span className="pw-rules-mark" aria-hidden="true">{ok ? '✓' : '○'}</span>
              {rule.label}
              {/* Spoken only when it changes, so a screen reader hears
                  "met" rather than the whole list again. */}
              <span className="sr-only">{ok ? ' — met' : ' — still needed'}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
